import React from 'react'

import './Content.scss'
import classy from 'shared/utils/classy'

export interface ModalContentProps {
  children: React.ReactNode
  allowOverflow?: boolean
  'data-testid'?: string
  fullscreen?: boolean
  noGap?: boolean
  noVerticalPadding?: boolean
  noHorizontalPadding?: boolean
}

const ModalContent = React.memo(
  ({
    children,
    allowOverflow = false,
    fullscreen = false,
    noGap = false,
    noVerticalPadding = false,
    noHorizontalPadding = false,
    'data-testid': dataTestId = 'modal-content',
  }: ModalContentProps) => {
    return (
      <div
        data-testid={dataTestId}
        className={classy(
          'ModalContent',
          allowOverflow && 'ModalContent--allow-overflow',
          fullscreen && 'ModalContent--fullscreen',
          noGap && 'ModalContent--no-gap',
          noVerticalPadding && 'ModalContent--no-vertical-padding',
          noHorizontalPadding && 'ModalContent--no-horizontal-padding',
        )}
      >
        {children}
      </div>
    )
  },
)

ModalContent.displayName = 'Modal.Content'

export default ModalContent
